module.exports = __webpack_public_path__ + "img/blick-cashback.81af66fc.gif";